import { Link } from 'react-router-dom';

export default function PrivacyPolicyProPage() {
  return (
    <div className="legal-page min-h-screen bg-gray-50 py-8">
      <div className="max-w-3xl mx-auto px-4">
        {/* Logo */}
        <div className="text-center mb-8">
          <img
            src="/volovolo.png"
            alt="Volovolo"
            className="h-20 w-auto mx-auto"
          />
        </div>

        <div className="bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-2xl font-bold mb-6">
            Mentions Legales et Politique de Confidentialite de volovolo.pro
          </h1>

          {/* Mentions Legales */}
          <h2 className="text-xl font-bold mt-6 mb-4">Mentions legales</h2>
          <ul className="list-disc ml-6 space-y-2 text-gray-700">
            <li>Proprietaire : Adam Issam, Micro-Entreprise, SIREN 988922241, France.</li>
            <li>Directeur de publication : Adam Issam.</li>
            <li>
              Contact :{' '}
              <a href="mailto:contact@volovolo.pro" className="text-cyan-600 hover:underline">
                contact@volovolo.pro
              </a>
            </li>
          </ul>

          {/* Politique de Confidentialite */}
          <h2 className="text-xl font-bold mt-8 mb-4">Politique de Confidentialite</h2>

          <h3 className="text-lg font-semibold mt-6 mb-3">1. Collecte des donnees personnelles</h3>
          <p className="text-gray-700 mb-4">
            Nous collectons les donnees suivantes : nom, prenom, adresse email, adresse postale,
            numero de telephone, informations de paiement, donnees de navigation et cookies.
            Ces donnees sont collectees lors de la creation de compte, commandes, paiement,
            navigation et contact avec le support.
          </p>

          <h3 className="text-lg font-semibold mt-6 mb-3">2. Finalites du traitement</h3>
          <p className="text-gray-700 mb-2">Les donnees sont utilisees pour :</p>
          <ul className="list-disc ml-6 space-y-1 text-gray-700 mb-4">
            <li>La gestion des comptes utilisateurs et vendeurs.</li>
            <li>Le traitement et le suivi des commandes.</li>
            <li>La gestion des paiements (via Stripe).</li>
            <li>La prevention de la fraude.</li>
            <li>L'envoi d'informations commerciales (newsletter) si l'utilisateur y a consenti.</li>
          </ul>

          <h3 className="text-lg font-semibold mt-6 mb-3">3. Cookies</h3>
          <p className="text-gray-700 mb-4">
            Des cookies fonctionnels et analytiques peuvent etre installes pour ameliorer
            l'experience utilisateur et mesurer l'audience. Vous pouvez gerer vos preferences
            via notre banniere de consentement.
          </p>

          <h3 className="text-lg font-semibold mt-6 mb-3">4. Duree de conservation</h3>
          <p className="text-gray-700 mb-4">
            Les donnees sont conservees pour une duree conforme aux obligations legales
            (facturation, comptabilite) et au maximum 3 ans apres la derniere activite
            pour les donnees marketing.
          </p>

          <h3 className="text-lg font-semibold mt-6 mb-3">5. Destinataires</h3>
          <p className="text-gray-700 mb-4">
            Les donnees sont destinees a volovolo.pro, ses prestataires techniques
            (hebergeur, Stripe) et aux autorites competentes en cas d'obligation legale.
          </p>

          <h3 className="text-lg font-semibold mt-6 mb-3">6. Securite des donnees</h3>
          <p className="text-gray-700 mb-4">
            Nous mettons en place des mesures techniques et organisationnelles pour proteger
            vos donnees. Les paiements sont securises par Stripe.
          </p>

          <h3 className="text-lg font-semibold mt-6 mb-3">7. Droits de l'utilisateur</h3>
          <p className="text-gray-700 mb-4">
            Conformement au RGPD, vous disposez d'un droit d'acces, de rectification,
            de suppression, d'opposition et de portabilite de vos donnees. Vous pouvez
            exercer vos droits a l'adresse{' '}
            <a href="mailto:contact@volovolo.pro" className="text-cyan-600 hover:underline">
              contact@volovolo.pro
            </a>.
          </p>

          <h3 className="text-lg font-semibold mt-6 mb-3">8. Reclamation</h3>
          <p className="text-gray-700 mb-4">
            Vous pouvez introduire une reclamation aupres de la CNIL (
            <a
              href="https://www.cnil.fr"
              target="_blank"
              rel="noopener noreferrer"
              className="text-cyan-600 hover:underline"
            >
              www.cnil.fr
            </a>
            ) si vous estimez que vos droits ne sont pas respectes.
          </p>

          <h3 className="text-lg font-semibold mt-6 mb-3">9. Modification de la politique</h3>
          <p className="text-gray-700 mb-4">
            volovolo.pro se reserve le droit de modifier la presente politique.
            Vous serez informe par email ou notification sur le site.
          </p>

          {/* Footer Links */}
          <div className="mt-8 pt-6 border-t border-gray-200">
            <div className="flex flex-wrap gap-4 text-sm text-gray-600">
              <Link to="/cgv/pro" className="text-cyan-600 hover:underline">
                Conditions Generales de Vente
              </Link>
              <Link to="/terms-of-use/pro" className="text-cyan-600 hover:underline">
                Conditions Generales d'Utilisation
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
